module.exports = __webpack_public_path__ + "sunsemweb/img/nbanner2.96c64bd5.png";